var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M7 3h10a1 1 0 0 1 .906.576l.043.108 1.728 5.185A4 4 0 0 1 22 12.501v4a2 2 0 0 1-2 2v.5a1.5 1.5 0 0 1-3 0v-.5H7v.5a1.5 1.5 0 0 1-3 0v-.5a2 2 0 0 1-2-2v-4A4 4 0 0 1 4.323 8.87L6.05 3.684a1 1 0 0 1 .833-.677L7 3h10H7zm11 7.501H6a2 2 0 0 0-2 2v4h16v-4a2 2 0 0 0-2-2zM7.5 12a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm9 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-.22-7H7.72L6.554 8.501h10.893L16.279 5z" })
  );
});